import React, { useEffect, useState } from 'react';
import ComingSoon from '../pages/ComingSoon';

const STORAGE_KEY = 'physPreviewUnlocked';

export default function MaintenanceGuard({ children }) {
  const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  const expectedToken = process.env.REACT_APP_PREVIEW_TOKEN;

  const [unlocked, setUnlocked] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  });

  useEffect(() => {
    if (!maintenanceMode) return;
    const params = new URLSearchParams(window.location.search);
    const provided = params.get('preview');
    if (provided && expectedToken && provided === expectedToken) {
      window.localStorage.setItem(STORAGE_KEY, 'true');
      setUnlocked(true);
      params.delete('preview');
      const newSearch = params.toString();
      const newUrl =
        window.location.pathname +
        (newSearch ? `?${newSearch}` : '') +
        window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }, [maintenanceMode, expectedToken]);

  if (!maintenanceMode) return children;
  if (unlocked) return children;
  return <ComingSoon />;
}
